﻿import { defineComponent } from 'vue';
import axios from 'axios';
import { useBookingStore } from '../../../store/bookingstore';

import trip_summary from "../common/trip_summary.vue"
import trip_summary_discount from "../common/trip_summary_discount.vue"
import itinerary_breakdown from "../common/itinerary_breakdown.vue";

import { Booking } from "../../../services/booking";
import { Payment } from "../../../services/payment";

import { Currency_Service } from "../../../../system/services/currency";

const Book: Booking = new Booking();
const Pay: Payment = new Payment();
const Currency_Services: Currency_Service = new Currency_Service();

import { response } from "../../../objects/v1_3/payment/initialise/response";
import { response_method } from "../../../objects/v1_3/payment/initialise/response_method";

import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { passenger } from "../../../objects/v1_2/Booking/Passenger";

import { Booking_Passengers, First_Invalid_Passenger, Normalise_Passenger, Rules_Context } from "./passenger_rules";

export default defineComponent({
    name: "checkout_trip_summary",
    components: {
        trip_summary,
        trip_summary_discount,
        itinerary_breakdown
    },
    props: {
    },
    data() {
        return {
            checkout: "Check out now",
            full_payment: true,
            deposit: false,
            agreeCheckbox: false as Boolean,
            // Replaced by the displayCompleteRequired computed below: a one-shot flag never cleared once the forms became valid.
            // displayCompleteRequired: false as Boolean,
            saveFailed: false as Boolean,
            isloading: false as Boolean
        }
    },
    setup() {
        const bookingStore = useBookingStore();

        return {
            bookingStore
        }
    },
    computed: {
        // Shown after a checkout attempt, and only while a passenger is still invalid; clears as soon as the drafts are complete.
        displayCompleteRequired(): boolean {
            const booking: booking_search_group = this.$store.getters.get_Booking;
            if (!this.bookingStore.show_passenger_errors || !booking) {
                return false;
            }
            return First_Invalid_Passenger(booking, this.bookingStore.passenger_drafts, Rules_Context(booking)) !== -1;
        }
    },
    methods: {
        async check_out() {
            if (this.isPaymentLink()) {
                this.Continue_To_Payment();
                return;
            }

            const booking: booking_search_group = this.$store.getters.get_Booking;
            const passengers = Booking_Passengers(booking);

            // From now on every missing field is flagged, not only the ones the customer has touched.
            this.bookingStore.show_passenger_errors = true;
            const invalid_index = First_Invalid_Passenger(booking, this.bookingStore.passenger_drafts, Rules_Context(booking));
            if (invalid_index !== -1) {
                // this.displayCompleteRequired = true; (now computed)
                this.Go_To_Passenger(passengers[invalid_index]);
                return;
            }

            // this.displayCompleteRequired = false; (now computed)
            this.saveFailed = false;
            this.isloading = true;
            try {
                passengers.forEach(p => Normalise_Passenger(p));

                // One save for all passengers, then reload so the stored booking matches the server.
                const response = await Book.Update_Booking_Passengers(booking, this.$store.getters.get_Agent_Login, this.$store.getters.get_Currency);
                if (!response.ok) {
                    throw new Error("Saving passengers failed with status " + response.status);
                }
                this.$store.commit("Setup_Booking", { Booking_Details: await Book.Get_Book(String(booking.group_booking_id), this.$store.getters.get_Agent_Login) });

                if (this.bookingStore.newsletter_opt_in && !this.isAgent_Login()) {
                    this.Subscribe_Newsletter(passengers[0]);
                }

                this.bookingStore.show_passenger_errors = false;
                this.Continue_To_Payment();
            } catch (error) {
                console.error(error);
                this.saveFailed = true;
            } finally {
                this.isloading = false;
            }
        },
        Continue_To_Payment() {
            this.$store.commit("Set_Payment_Full_Payment", { Payment: this.full_payment });
            this.$store.commit("Set_Payment_Deposit", { Payment: this.deposit });
            this.$router.push({ path: "/creditcard" });
        },
        Go_To_Passenger(p: passenger | undefined) {
            if (!p) {
                return;
            }
            this.$nextTick(() => {
                const card = document.getElementById("passenger_" + p.passenger_identifier);
                card?.scrollIntoView({ behavior: "smooth", block: "start" });
                card?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus({ preventScroll: true });
            });
        },
        // Newsletter sign-up for the lead passenger (consumer bookings only); failures are logged, never block checkout.
        Subscribe_Newsletter(lead: passenger | undefined) {
            if (!lead?.email) {
                return;
            }
            const headers = { "User-Agent": String(import.meta.env.VITE_GA_APP_NAME), "Authorization": "Basic " + String(import.meta.env.VITE_FLODESK_KEY) };

            axios.post(String(import.meta.env.VITE_FLODESK_API), {
                email: lead.email,
                first_name: lead.first_name,
                last_name: lead.family_name,
            }, { headers })
                .then(() => axios.post('https://api.flodesk.com/v1/subscribers/' + lead.email + '/segments', {
                    id_or_email: lead.email,
                    segment_ids: [String(import.meta.env.VITE_FLODESK_SEGMENT)]
                }, { headers }))
                .catch((error) => { console.error(error); });
        },
        show_full_payment(): boolean {
            let total_outstanding_amount = this.get_total_outstanding();

            return (total_outstanding_amount > 0);
        },
        show_deposit_payment(): boolean {

            let deposit_amount = this.get_Total_Deposit();
            let total_outstanding_amount = this.get_total_outstanding();

            return (deposit_amount > 0 && deposit_amount !== total_outstanding_amount);
        },
        No_Deposit(): boolean {
            var total_outstanding = Book.get_total_outstanding(this.$store.getters.get_Booking?.trips);
            var total_deposit = Book.get_Total_Deposit(this.$store.getters.get_Booking);

            if (this.has_Payment_Session()) {
                total_outstanding = Pay.get_total_outstanding(this.$store.getters.get_Payment_Session);
                total_deposit = Pay.get_Total_Deposit(this.$store.getters.get_Payment_Session);
                
                let payment_session : request_payment_initialise_internal = this.$store.getters.get_Payment_Session

                if (payment_session?.payment_initialise?.deposit == true) {
                    this.deposit_selected();
                }
            }

            return total_outstanding == total_deposit;
        },
        has_Payment_Session() : boolean {
            let Payment_Session = this.$store.getters.get_Payment_Session;
            if (!(Payment_Session == undefined || Payment_Session == null || Payment_Session.payment_session == null)) {
                return true;
            }
            return false;
        },
        get_total_outstanding(): number {
            var total_outstanding = 0;

            if (this.has_Payment_Session()) {
                total_outstanding = Pay.get_total_outstanding(this.$store.getters.get_Payment_Session);
            } else {
                total_outstanding = Book.get_total_outstanding(this.$store.getters.get_Booking?.trips);
            }

            return total_outstanding;
        },
        get_total_outstanding_Formatted(): string {
            var total_outstanding = 0;

            if (this.has_Payment_Session()) {
                total_outstanding = Pay.get_total_outstanding(this.$store.getters.get_Payment_Session);
            } else {
                total_outstanding = Book.get_total_outstanding(this.$store.getters.get_Booking?.trips);
            }

            return Currency_Services.Format_Currency(total_outstanding, this.$store.getters.get_Currency);
        },
        get_Total_Deposit(): number {
            var total_deposit = 0;

            if (this.has_Payment_Session()) {
                total_deposit = Pay.get_Total_Deposit(this.$store.getters.get_Payment_Session);
            } else {
                total_deposit = Book.get_Total_Deposit(this.$store.getters.get_Booking);
            }

            return total_deposit;
        },
        get_Total_Deposit_Formatted(): string {
            var total_deposit = 0;

            if (this.has_Payment_Session()) {
                total_deposit = Pay.get_Total_Deposit(this.$store.getters.get_Payment_Session);
            } else {
                total_deposit = Book.get_Total_Deposit(this.$store.getters.get_Booking);
            }

            return Currency_Services.Format_Currency(total_deposit, this.$store.getters.get_Currency);
        },
        get_Total_Selected_Formatted(): string {
            if (this.full_payment == true) {
                return this.get_total_outstanding_Formatted();
            }

            if (this.deposit == true) {
                return this.get_Total_Deposit_Formatted();
            }

            return "";
        },
        get_Balance(): string {
            return Currency_Services.Format_Currency(Book.get_Balance(this.$store.getters.get_Booking), this.$store.getters.get_Currency);
        },
        full_payment_selected() {
            this.full_payment = true;
            this.deposit = false;
        },
        deposit_selected() {
            this.full_payment = false;
            this.deposit = true;
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency?.currency_info?.iso_currency_code;
        },
        terms_policy(): string {
            return String(import.meta.env.VITE_FOOTER_POLICY_TERMS);
        },
        get_Contact_Text(): string {
            return String(import.meta.env.VITE_DEFAULT_CONTACT_TEXT);
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isPaymentLink(): boolean {
            return window.location.href.toLowerCase().includes('paylink');
        }
    },
    mounted() {
        if (this.$store.getters.get_Agent_Login?.valid_login == true) {
            this.agreeCheckbox = true;
        }


    }
})